import { commitChangesEmployeesBulkSession } from "../../infrastructure/repository/employees-repository";
import { findEmployeesWithFields } from "../../infrastructure/employees-cache";
import { translate } from "../../infrastructure/translate/localization";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { redirect } from "../../app/routes/Routes";
import { displayEmployeesPage } from "./displays/display-employees-page";

export async function changeEditEmployeesBulkSession(employeesForUpload) {
  try {
    const companyId = await findCompanyId();
    await commitChangesEmployeesBulkSession(companyId);
    await findEmployeesWithFields({ companyId });

    addContextLog(
      "info",
      "commitChangesEmployeesBulkSession",
      "display-screen",
      { companyId }
    );
    if (employeesForUpload === 1) {
      showSuccessMessage(
        translate("edit-employees.edit-employees-upload-success-single", {
          numEmployees: employeesForUpload,
        })
      );
    } else {
      showSuccessMessage(
        translate("edit-employees.edit-employees-upload-success", {
          numEmployees: employeesForUpload,
        })
      );
    }
    redirect("/v2/employees");

    displayEmployeesPage();
  } catch (e) {
    logError(e, `Error to commitChangesEmployeesBulkSession`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
